<template>
  <section class="grid grid-cols-12 gap-5">
    <div class="col-span-12 flex flex-col gap-5">
      <div class="flex items-center justify-between mb-4">
        <div>
          <h4 class="capitalize">{{ currentObjective.name }}</h4>
          <p v-if="classroomName">
            {{ $t("labels.generic", { pt: "Turma: ", en: "Classroom: " }) }}
            {{ classroomName }}
          </p>
        </div>
        <div class="flex flex-row justify-end items-center gap-2">
          <p>{{ $t("labels.generic", { pt: "Objetivo", en: "Objective" }) }}</p>
          <Dropdown
            v-model="currentObjective"
            inputId="dd-city"
            :options="objectives"
            optionLabel="name"
            class="w-[20%] min-w-[250px] md:w-14rem"
            @change="goToObjective()"
          />
        </div>
      </div>
      <div class="flex items-center justify-between mb-4">
        <h4 class="mb-2">
          {{ $t("stats.course.sidebar.general") }}
        </h4>
      </div>
    </div>
    <div v-for="(item, i) in data" :key="i" class="col-span-12 lg:col-span-4">
      <Card :data="item" :isEmpty="item.empty"> </Card>
    </div>
  </section>
</template>

<script lang="ts">
import { LearningObjective } from "@/models/learning-objective.model";
import { QueryParams } from "@/models/query-params.model";
import { GeneralInfoIndividualObjective } from "@/models/stats.model";
import { GoToRoute } from "@/utils/go-to.util";
import { delay, last, take } from "rxjs";
import { defineAsyncComponent, defineComponent } from "vue";
import { GeneralService } from "./general.service";

const Card = defineAsyncComponent(() => import("../../Card/card.vue"));
export default defineComponent({
  name: "generalInfoObjective",
  components: { Card },
  emits: ["onGetCurrentObjective"],
  computed: {
    statsService(): GeneralService {
      return new GeneralService();
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
    classroomName(): string {
      return JSON.parse(localStorage.getItem("objClassroomName") as string);
    },
  },
  watch: {
    $route() {
      if (this.$route.name === "statsObjective") this.getObjective();
    },
  },
  data() {
    return {
      data: [] as any,
      objective: new GeneralInfoIndividualObjective(),
      objectives: [] as LearningObjective[],
      currentObjective: "" as any,
      btnLoading: false as boolean,
      csv: new GeneralInfoIndividualObjective(),
      params: {} as Omit<QueryParams, "page" | "size">,
    };
  },
  mounted() {
    this.getAllObjectives();
    this.getObjective();
  },
  methods: {
    getObjective(): void {
      this.data = [];
      this.statsService.general.pipe(take(2), last()).subscribe({
        next: (response: any) => {
          this.objective = response;
          let item = {
            title: this.objective.totalQuizAverage
              ? this.objective.totalQuizAverage
              : 0,
            info: "Média geral dos quizzes",
            icon: require("@/assets/images/course-student/quiz-average.svg"),
            empty: false,
          };
          this.data.push(item);
        },
      });
      this.statsService.getGeneralFromObjective(
        String(this.$route.params.objectiveId)
      );
    },
    getAllObjectives(): void {
      this.params.courseId = String(this.$route.params.courseId);
      this.statsService.objectives.pipe(take(2), last(), delay(500)).subscribe({
        next: (response: any) => {
          this.objectives = response.learningObjectiveOverviews;
          this.objectives.forEach((objective) => {
            if (objective.id === String(this.$route.params.objectiveId)) {
              this.currentObjective = objective;
              this.$emit("onGetCurrentObjective", objective);
            }
          });
        },
      });
      this.statsService.getAllObjectivesByCourse({ ...this.params, size: 100 });
    },
    goToObjective(): void {
      let data = {
        courseId: String(this.$route.params.courseId),
        objectiveId: this.currentObjective.id,
        objectiveName: this.currentObjective.name,
      };

      // GeneralService.setObjective(data);
      this.go.redirectToPage("statsObjective", data);
    },
  },
});
</script>
